import { FORBIDDEN_FILE_UPLOAD_TYPES } from "../modules/Files/Files.constants";

/**
 *
 * @param file The file for which we have to check type
 * @returns
 */
export const checkIsFileForbiddenType = (file: File) => {
    return FORBIDDEN_FILE_UPLOAD_TYPES.some(type =>
        file.name.toLowerCase().endsWith(type)
    );
};

/**
 * Calculates the readable file size string from given size in bytes.
 * @param sizeInBytes The size of the file in bytes.
 * @param options Optional parameter for precision of the output string.
 * @returns An object containing postfix (unit), size value, and formatted output string.
 */
export const getFileSizeString = (
    sizeInBytes: number,
    options?: { precision?: number }
) => {
    // Default precision to 2 if not provided
    const { precision = 2 } = options || {};

    let postfix: "B" | "KB" | "MB" | "GB" = "B"; // Default postfix is bytes
    let sizeVal: number = sizeInBytes; // Default size is the provided size in bytes

    // Convert to KB if size is larger than 1024 bytes
    if (sizeInBytes > 1024) {
        sizeVal = sizeInBytes / 1024;
        postfix = "KB";
    }

    // Convert to MB if size is larger than 1024 KB
    if (sizeVal > 1024) {
        sizeVal /= 1024;
        postfix = "MB";
    }

    // Convert to GB if size is larger than 1024 MB
    if (sizeVal > 1024) {
        sizeVal /= 1024;
        postfix = "GB";
    }

    // Format output string with specified precision
    return {
        postfix,
        sizeVal,
        outputString: `${sizeVal.toPrecision(precision)} ${postfix}`,
    };
};

export const getVideoThumbnailFileName = (prefix: string): string => {
    return `${prefix}_${new Date().getTime()}_thumbnail.png`;
};
